
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ContiGif from '../header/images/Conti_gif.gif';
import ContiStartQuizGif from '../header/images/Conti_start_quiz.gif';

import {
  faTimes,
  faChevronLeft,
  faBook,
  faHandshake,
  faGlobe,
  faCheck,
  faQuestionCircle,
  faArrowLeft,
  faBullseye,
  faSchool,
  faBriefcase,
  faBuilding,
  faBrain,
  faClock,
  faCheckCircle,
  faFileInvoice,
  faBullhorn,
  faUserGroup,
  faRadio,
   faLayerGroup
} from '@fortawesome/free-solid-svg-icons';
import {
  faInstagram,
  faLinkedin,
  faTiktok
} from '@fortawesome/free-brands-svg-icons';
import EmiAsat from './EmiAsat';
import './QuizStart.css';
import '../content/cursuri/chaptercontainer.css';

// Mesaje personalizate pentru al cincilea quiz
const fifthQuizMessages = {
  '5 minute pe zi': 'Perfect pentru putin cate putin, in fiecare zi.',
  '10–15 minute pe zi': 'Un ritm echilibrat, usor de tinut.',
  '30 minute pe zi': 'Super! Avem timp sa aprofundam si sa exersam.'
};






// Mesaje personalizate pentru al treilea quiz
const thirdQuizMessages = {
  'Incepator total': 'Toata lumea incepe de undeva. Hai sa punem bazele pas cu pas',
  'Am notiuni de baza': 'Ai deja cateva notiuni. Te ajutam sa le legi corect si sa capete sens',
  'Ma descurc bine': 'Super! Hai sa consolidam cunostintele si sa trecem la aplicatii mai practice',
  'Avansat': 'Perfect. Ne concentram pe aplicatii, decizii contabile si situatii reale'
};

const quizSteps = [
{
question: 'Ce iti doresti sa inveti?',
icon: faQuestionCircle,
options: [
{ label: 'Bazele contabilitatii', icon: faBook },
{ label: 'Contabilitate primara', icon: faFileInvoice },
{ label: 'Contabilitate financiara', icon: faHandshake },
{ label: 'Cate putin din fiecare', icon: faLayerGroup },
{ label: 'Nu stiu inca', icon: faQuestionCircle }
]
}

,
  {
    question: 'De ce vrei sa inveti contabilitate?',
    icon: faBook,
    options: [
      { label: 'Pentru scoala sau facultate', icon: faSchool },
      { label: 'Pentru job', icon: faBriefcase },
      { label: 'Pentru firma mea', icon: faBuilding },
      { label: 'Pentru cultura generala', icon: faBrain },
      { label: 'Recapitulare cunostinte', icon: faCheckCircle }
    ]
  },
{
  question: 'Cat de familiar esti cu contabilitatea?',
  icon: faBrain,
  multiple: false,
  options: [
    { label: 'Incepator total', icon: faQuestionCircle },
    { label: 'Am notiuni de baza', icon: faBook },
    { label: 'Ma descurc bine', icon: faCheckCircle },
    { label: 'Avansat', icon: faBrain }
  ]
},
  {
    question: 'Cum vrei sa inveti?',
    icon: faBook,
    options: [
      { label: 'Explicatii simple', icon: faBook },
      { label: 'Quiz-uri interactive', icon: faQuestionCircle },
      { label: 'Aplicatii practice', icon: faCheckCircle }
    ]
  },
{
  question: 'Cat timp vrei sa aloci?',
  icon: faClock,
  multiple: false,
  options: [
    { label: '5 minute pe zi', icon: faClock },
    { label: '10–15 minute pe zi', icon: faClock },
    { label: '30 minute pe zi', icon: faClock }
  ]
},




  {
    question: 'Care e obiectivul tau principal?',
    icon: faCheckCircle,
    options: [
      { label: 'Sa inteleg contabilitatea', icon: faBook },
      { label: 'Sa obtin un job', icon: faBriefcase },
      { label: 'Sa promovez examene', icon: faSchool },
      { label: 'Sa gestionez firma', icon: faBuilding },
      { label: 'Sa ma perfectionez', icon: faBrain }
    ]
  },
  {
question: 'De unde ai auzit de ContaLearn?',
icon: faBullhorn,
options: [
{ label: 'Recomandare', icon: faUserGroup },
{ label: 'Instagram', icon: faInstagram },
{ label: 'LinkedIn', icon: faLinkedin },
{ label: 'TikTok', icon: faTiktok },
{ label: 'Radio', icon: faRadio }
]
}

];

const scrollViewportToTop = (container) => {
  const root = document.documentElement;
  const body = document.body;
  const appContainer = document.querySelector('.d-flex.flex-column.v-100');

  if (container) {
    container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  if (appContainer) {
    appContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  root.scrollTop = 0;
  body.scrollTop = 0;
};

const QuizStart = () => {
  const quizContainerRef = useRef(null);
  const quizBodyRef = useRef(null);

  const [step, setStep] = useState(0);

  // Single select = null
  // Multiple select = []
  const [selected, setSelected] = useState(
    quizSteps.map((quiz) => (quiz.multiple === false ? null : []))
  );

  const [isQuizBodyScrollable, setIsQuizBodyScrollable] = useState(false);

  useEffect(() => {
    scrollViewportToTop(quizBodyRef.current);
  }, [step]);

  useEffect(() => {
    const updateScrollableState = () => {
      const quizBody = quizBodyRef.current;

      if (!quizBody) {
        return;
      }

      if (!window.matchMedia('(max-width: 900px)').matches) {
        setIsQuizBodyScrollable(false);
        return;
      }

      const hasOverflow =
        quizBody.scrollHeight > quizBody.clientHeight + 1;

      setIsQuizBodyScrollable(hasOverflow);

      if (!hasOverflow) {
        quizBody.scrollTop = 0;
      }
    };

    updateScrollableState();

    const animationFrameId =
      window.requestAnimationFrame(updateScrollableState);

    window.addEventListener('resize', updateScrollableState);

    let resizeObserver;

    if (
      typeof ResizeObserver !== 'undefined' &&
      quizBodyRef.current
    ) {
      resizeObserver = new ResizeObserver(updateScrollableState);
      resizeObserver.observe(quizBodyRef.current);
    }

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', updateScrollableState);

      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [step, selected]);

  useEffect(() => {
    const quizBody = quizBodyRef.current;

    if (!quizBody) {
      return undefined;
    }

    const preventTouchScroll = (event) => {
      if (!window.matchMedia('(max-width: 900px)').matches) {
        return;
      }

      if (!isQuizBodyScrollable) {
        event.preventDefault();
      }
    };

    quizBody.addEventListener('touchmove', preventTouchScroll, {
      passive: false
    });

    return () => {
      quizBody.removeEventListener(
        'touchmove',
        preventTouchScroll
      );
    };
  }, [isQuizBodyScrollable]);

  useEffect(() => {
    const quizContainer = quizContainerRef.current;
    const quizBody = quizBodyRef.current;

    if (!quizContainer || !quizBody) {
      return undefined;
    }

    const preventContainerScroll = (event) => {
      if (!window.matchMedia('(max-width: 900px)').matches) {
        return;
      }

      const touchInsideQuizBody =
        quizBody.contains(event.target);

      if (!touchInsideQuizBody || !isQuizBodyScrollable) {
        event.preventDefault();
      }
    };

    quizContainer.addEventListener(
      'touchmove',
      preventContainerScroll,
      { passive: false }
    );

    return () => {
      quizContainer.removeEventListener(
        'touchmove',
        preventContainerScroll
      );
    };
  }, [isQuizBodyScrollable]);

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;

    const previousRootOverflow = root.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    const previousBodyTouchAction = body.style.touchAction;

    const applyMobileScrollLock = () => {
      if (window.matchMedia('(max-width: 900px)').matches) {
        root.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        body.style.touchAction = previousBodyTouchAction;

        scrollViewportToTop(quizBodyRef.current);

        return;
      }

      root.style.overflow = previousRootOverflow;
      body.style.overflow = previousBodyOverflow;
      body.style.touchAction = previousBodyTouchAction;
    };

    applyMobileScrollLock();

    window.addEventListener(
      'resize',
      applyMobileScrollLock
    );

    return () => {
      window.removeEventListener(
        'resize',
        applyMobileScrollLock
      );

      root.style.overflow = previousRootOverflow;
      body.style.overflow = previousBodyOverflow;
      body.style.touchAction = previousBodyTouchAction;
    };
  }, []);

  // =====================================================
  // SELECTARE RASPUNSURI
  // =====================================================

  const handleSelect = (option) => {
    const quizIndex = step - 1;
    const quiz = quizSteps[quizIndex];

    setSelected((prevSelected) => {
      const newSelected = [...prevSelected];

      // SINGLE SELECT
      if (quiz.multiple === false) {
        newSelected[quizIndex] = option;
        return newSelected;
      }

      // MULTIPLE SELECT
      const currentSelections = Array.isArray(
        newSelected[quizIndex]
      )
        ? newSelected[quizIndex]
        : [];

      // Deselectare
      if (currentSelections.includes(option)) {
        newSelected[quizIndex] =
          currentSelections.filter(
            (item) => item !== option
          );
      } else {
        // Selectare
        newSelected[quizIndex] = [
          ...currentSelections,
          option
        ];
      }

      return newSelected;
    });
  };

  // =====================================================
  // VERIFICA DACA EXISTA CEL PUTIN UN RASPUNS
  // =====================================================

  const hasSelection = (quizIndex) => {
    const answer = selected[quizIndex];

    if (Array.isArray(answer)) {
      return answer.length > 0;
    }

    return Boolean(answer);
  };

  // =====================================================
  // CONTINUA
  // =====================================================

  const handleContinue = () => {
    const isOptionStep =
      step >= 1 && step <= quizSteps.length;

    if (
      isOptionStep &&
      !hasSelection(step - 1)
    ) {
      return;
    }

    if (step < quizSteps.length + 2) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    if (step <= 1) {
      return;
    }

    setStep((prevStep) => prevStep - 1);
  };

  // =====================================================
  // PROGRESS
  // =====================================================

  const progressStepsCount = quizSteps.length + 1;

  const progress =
    step === 0
      ? 0
      : Math.min(step, progressStepsCount) /
        progressStepsCount;

  const isSummaryStep =
    step === quizSteps.length + 1;

  const isFinalCtaStep =
    step === quizSteps.length + 2;

  // =====================================================
  // HELPERS PENTRU MULTIPLE SELECT
  // =====================================================

  // Intoarce intotdeauna array.
  const getAnswersArray = (index) => {
    const answer = selected[index];

    if (!answer) {
      return [];
    }

    return Array.isArray(answer)
      ? answer
      : [answer];
  };

  // Construieste mesajele Conti pentru toate
  // raspunsurile selectate.
const getQuizMessage = (quizIndex, messages) => {
  const answer = selected[quizIndex];

  if (!answer) {
    return null;
  }

  return messages?.[answer] || null;
};

const summaryItems = [
  {
    icon: faBullseye,
    title: 'Continut structurat',
    text: 'pentru invatare usoara'
  },
  {
    icon: faBrain,
    title: 'Invata pas cu pas',
    text: 'de la baza la aplicatii'
  },
  {
    icon: faClock,
    title: 'Progreseaza in ritmul',
    text: 'ales de tine'
  }
];

  // =====================================================
  // DATE SALVATE
  // =====================================================


const onboardingAnswers = {
  learning_goal: selected[0] || [],
  reason: selected[1] || [],
  experience: selected[2] || null,
  learning_style: selected[3] || [],
  time_commitment: selected[4] || null,
  objective: selected[5] || [],
  source: selected[6] || []
};


  const handleCreateAccountClick = () => {
    try {
      localStorage.setItem(
        'onboardingAnswers',
        JSON.stringify(onboardingAnswers)
      );
    } catch (error) {
      // Inregistrarea continua chiar daca
      // localStorage nu este disponibil.
    }
  };





  // =====================================================
  // MESAJUL AFISAT DE CONTI
  // =====================================================

const getCurrentQuizMessage = () => {
  const currentQuiz = quizSteps[step - 1];

  // Nu afisam mesaje personalizate pentru multiple select
  if (!currentQuiz || currentQuiz.multiple !== false) {
    return null;
  }

  // Quiz single select:
  // Cat de familiar esti cu contabilitatea?
  if (step === 3) {
    return getQuizMessage(
      2,
      thirdQuizMessages
    );
  }

  // Quiz single select:
  // Cat timp vrei sa aloci?
  if (step === 5) {
    return getQuizMessage(
      4,
      fifthQuizMessages
    );
  }

  return null;
};

  const showHeader = !isFinalCtaStep;

  const progressWidth =
    step === 0
      ? 0
      : isSummaryStep
      ? 100
      : progress * 100;

  const currentQuizMessage =
    !isSummaryStep &&
    !isFinalCtaStep &&
    step > 0
      ? getCurrentQuizMessage()
      : null;

  return (
    <div
      ref={quizContainerRef}
      className="quiz-start-container quiz-fullscreen"
    >
      <div className="quiz-shell">

        {showHeader ? (
          <div className="quiz-header">

            <button
              type="button"
              className="quiz-back-btn"
              aria-label="Inapoi"
              onClick={handleBack}
              disabled={step <= 1}
            >
              <FontAwesomeIcon
                icon={faChevronLeft}
              />
            </button>

            <div className="quiz-progress-bar-wrap">
              <div className="quiz-progress-bar-bg">
                <div
                  className="quiz-progress-bar"
                  style={{
                    width: `${progressWidth}%`
                  }}
                />
              </div>
            </div>

            <button
              type="button"
              className="quiz-close-btn"
              aria-label="Inchide quiz"
              onClick={() =>
                window.history.back()
              }
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

          </div>
        ) : null}

        <div
          ref={quizBodyRef}
          className={`quiz-body${
            isQuizBodyScrollable
              ? ' quiz-body-scrollable'
              : ' quiz-body-static'
          }`}
        >

          {/* INTRO */}

          {step === 0 ? (
            <div className="conti-intro">

              <div className="conti-speech-bubble">
                Salutare, eu sunt Conti!
                <div className="conti-speech-arrow" />
              </div>

              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <img
                  src={ContiGif}
                  alt="Conti mascot"
                  className="conti-mascot"
                />

                <div className="conti-mascot-shadow" />
              </div>

            </div>
         ) : isSummaryStep ? (

  /* PERSONALIZARE FINALA */

  <>
    <div className="quiz-question-row">

      <div className="quiz-mascot-wrap">

        <div className="quiz-mascot-img-wrap">
          <img
            src={ContiStartQuizGif}
            alt="Conti mascot"
            className="quiz-mascot-img"
          />

          <div className="quiz-mascot-shadow" />
        </div>

        <div
          className="quiz-question-bubble"
          style={{
            marginTop: 0,
            marginBottom: 0
          }}
        >
          Perfect! Acum stiu cum sa te ajut sa inveti mai usor.
        </div>

      </div>
    </div>

    <div className="quiz-personalization-grid">

      {summaryItems.map(({ icon, title, text }) => (
        <div
          key={title}
          className="quiz-personalization-card"
        >
          <div className="quiz-personalization-icon">
            <FontAwesomeIcon icon={icon} />
          </div>

          <div className="quiz-personalization-content">
            <strong>{title}</strong>
            <span>{text}</span>
          </div>
        </div>
      ))}

    </div>
  </>

) : isFinalCtaStep ? (
            /* FINAL */

            <div className="conti-intro">

              <div className="conti-speech-bubble">
                <p>
                  Mai ai doar un singur pas pentru a incepe.
                </p>

                <div className="conti-speech-arrow" />
              </div>

              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <img
                  src={ContiGif}
                  alt="Conti mascot"
                  className="conti-mascot"
                />

                <div className="conti-mascot-shadow" />
              </div>

            </div>

          ) : (

            /* QUIZ */

            <>
              <div className="quiz-question-row">

                <div className="quiz-mascot-wrap">

                  <div className="quiz-mascot-img-wrap">

                    <img
                      src={ContiStartQuizGif}
                      alt="Conti mascot"
                      className="quiz-mascot-img"
                    />

                    <div className="quiz-mascot-shadow" />

                  </div>

                  <div
                    className="quiz-question-bubble"
                    style={
                      currentQuizMessage
                        ? {
                            marginTop: 0,
                            marginBottom: 0
                          }
                        : undefined
                    }
                  >
                    {currentQuizMessage ||
                      quizSteps[step - 1].question}
                  </div>

                </div>
              </div>

              <div
                className={`quiz-options-grid${
                  quizSteps[step - 1].options.length > 3
                    ? ' quiz-options-grid-2col'
                    : ''
                }`}
              >

               {quizSteps[step - 1].options.map((option) => {
  const currentQuiz = quizSteps[step - 1];
  const currentAnswer = selected[step - 1];

  const isMultiple = currentQuiz.multiple !== false;

  const isSelected = Array.isArray(currentAnswer)
    ? currentAnswer.includes(option.label)
    : currentAnswer === option.label;

  return (
    <button
      key={option.label}
      type="button"
      className={`quiz-answer-btn${
        isSelected ? ' quiz-answer-btn-selected' : ''
      }`}
      onClick={() => handleSelect(option.label)}
    >
      <FontAwesomeIcon
        icon={option.icon}
        className="quiz-answer-icon"
      />

      <span className="quiz-answer-label">
        {option.label}
      </span>

      {isMultiple && (
        <span
          className={`quiz-answer-checkbox${
            isSelected ? ' quiz-answer-checkbox-selected' : ''
          }`}
          aria-hidden="true"
        >
          {isSelected && (
            <FontAwesomeIcon icon={faCheck} />
          )}
        </span>
      )}
    </button>
  );
})}

              </div>
            </>
          )}

        </div>

        {/* FOOTER */}

        <div className="quiz-footer">

          <div className="group-quiz-start">

            {step === 0 ? (

              <button
                className="conti-intro-btn"
                onClick={() => setStep(1)}
                type="button"
              >
                Continua
              </button>

            ) : isFinalCtaStep ? (

              <Link
                to="/registrer"
                state={{ onboardingAnswers }}
                onClick={
                  handleCreateAccountClick
                }
                className="conti-intro-btn quiz-summary-cta"
              >
                Creeaza cont
              </Link>

            ) : (

              <button
                className="conti-intro-btn"
                onClick={handleContinue}
                disabled={
                  !isSummaryStep &&
                  !hasSelection(step - 1)
                }
                type="button"
              >
                Continua
              </button>

            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default QuizStart;